import { QueryClient } from "@tanstack/react-query";

import { isUnauthorizedError } from "@/lib/auth-failure";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: (failureCount, error) => {
				if (isUnauthorizedError(error)) {
					return false;
				}

				return failureCount < 3;
			},
		},
	},
});

declare global {
	interface Window {
		__TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
	}
}

if (window !== undefined) {
	window.__TANSTACK_QUERY_CLIENT__ = queryClient;
}
